import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCantileverLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 57,
	height: 12,
	viewBox: "0 0 57 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 12.001V6.00098V0.000976562C1.92077 1.03468 10.2075 5.40098 27.9884 5.40098C45.7693 5.40098 54.6048 1.03468 56.8 0.000976562V12.001C54.6048 10.9673 45.7693 6.60098 27.9884 6.60098C10.2075 6.60098 1.92077 10.9673 0 12.001Z",
		fill: "black",
		fillOpacity: .45
	})
});
export default SvgCantileverLogo;
